import React from 'react';
import ReferenceTable from '../References/ReferenceTable.js';

import './References.css';

function References() {
    return (
        <div className="references">
            <h2>Completed Projects</h2>
            <p>You don't take it from us. Here's a list of our completed projects with our satisfied customers.</p>
            <ReferenceTable />
            <p>
                Click <a href="/files/ReferenceListCopy.xls" download>here</a> to download our full list of references. 
            </p>
        </div>
    );
}

export default References;